import React, { useState, useContext, useEffect } from 'react'
import config from '../../config'
import { Picker, List, Toast, Icon, InputItem } from 'antd-mobile'
import { LanguageContext } from '../../contexts/LanguageContext'
import intl from 'react-intl-universal'
import MyNavBar from '../myComponents/MyHeader/MyNavBar'
import * as Styled from './MeIndexStyle'
import request from '../../utils/request'
import MyModal from '../myComponents/MyModal/MyModal'
import { Session } from '../../contexts/Session'
import './Melndex.css'
import { HospitalBasicInfoContext } from '../../contexts/HospitalBasicInfo'
import { OrderInfoContext } from '../../contexts/OrderInfo'
import BuleCross from '../Icons/BuleCross'
import EditButton from '../Icons/EditButton'
import IndexList from '../myComponents/IndexList/IndexList'
import Stethoscope from '../Icons/Stethoscope'
import People from '../Icons/People'
import Case from '../Icons/Case'
import GrayPull from '../Icons/GrayPull'
import Hospital from '../Icons/Hospital'
import Address from '../Icons/Address'
import Bed from '../Icons/Bed'
import RedPoint from '../Icons/RedPoint'
import RightIcon from '../Icons/RightIcon'
import StaffIcon from '../Icons/StaffIcon'
import AllergenIcon from '../Icons/Allergen'
import MyHeaderBg from '../myComponents/MyHeaderBg/MyHeaderBg'
import deepCopy from '../../utils/deepCopy'
const FormData = require('form-data')

export default function MeIndex (props) {
  const form = new FormData()
  const [sucPrompt, setSucPrompt] = useState(false)// 没有订单提示窗口
  const [unsucPrompt, setUnsucPrompt] = useState(false)// 有订单提示窗口
  const [number, setNumber] = useState(undefined) // 住院号
  const [patientName, setPatientName] = useState(undefined) // 病员姓名
  const [selectedDietaryAdvice, setSelectedDietaryAdvice] = useState([]) // 选中的饮食医嘱
  const [allergen, setAllergen] = useState('') // 过敏源
  const [floor, setFloor] = useState(undefined) // 楼层
  const [area, setArea] = useState(undefined) // 病区
  const [bedId, setBedId] = useState(undefined) // 床位号
  const [bedIdSave, setBedIdSave] = useState(undefined) // 床位号
  const [iphoneNumber, setIphoneNumber] = useState(undefined)// 电话号码
  const information = useContext(Session) // 订餐人信息
  const [message, setMessage] = useState(undefined) // 订单信息
  const [foodAdvicesExpansion, setFoodAdvicesExpansion] = useState(false)
  const [untiedSuccess, setUntiedSuccess] = useState(false)// 解绑成功窗口显示
  const [editUnsucFir, setUnsucFir] = useState(false)// 修改饮食医嘱失败1102
  const [editUnsucSec, setUnsucSec] = useState(false)// 修改饮食医嘱失败1405
  // 饮食医嘱病床号====================================
  const [DietaryAdvice, setDietaryAdvice] = useState([]) // 真正后端的饮食医嘱
  const [foodIconState, setfoodIconState] = useState(true)// 控制饮食医嘱上下拉图标
  const [isFpspatient, setIsFpspatient] = useState(true)// 是否是FPS维护的病人
  const [editState, setEditState] = useState(false)// 修改栏是否呈现
  const [positionEditable, setPositionEditable] = useState(true) // 床位信息是否可编辑
  const [selectedPosition, setSelectedPosition] = useState([]) // 用户选择的床位数组
  const [areas, setAreas] = useState([]) // 该医院的所有病区数组(包含了病区，楼层，床位的所有数据)，会根据用户的选择动态变化
  const [areasArr, setAreasArr] = useState([]) // 从后台读取的所有病区数组
  const [defaultValue, setDefaultValue] = useState([])// 饮食医嘱id数组
  const [visible, setVisible] = useState(false)
  const [foodAdviceDataSource, setFoodAdviceDataSource] = useState([]) // 饮食医嘱的option标签数组
  const [selectedDietaryAdviceObj, setSelectedDietaryAdviceObj] = useState([]) // 饮食医嘱(既有value也有id)
  const [saveTip, setSaveTip] = useState(false)// 是否保存提示框
  const [errmessage, setErrMessage] = useState(undefined)
  // 定时任务标志位
  // 饮食医嘱病床号=======================================
  const HospitalBasicInfo = useContext(HospitalBasicInfoContext)
  const OrderInfo = useContext(OrderInfoContext)
  const data = [{
    label: <div key={'zh'} style={{ width: '100%', textAlign: 'center' }}>中文</div>,
    value: 'zh'
  }, {
    label: <div key={'en'} style={{ width: '100%', textAlign: 'center' }}>English</div>,
    value: 'en'
  }]
  const languageContext = useContext(LanguageContext)
  const languageArray = ({
    zh: '中文',
    en: 'English'
  })
  const [selectedLanguage, setSelectedLanguage] = useState([languageContext.locale])
  // 提取饮食医嘱到一个数组中
  function foodAdvices () {
    var foodAdvices = selectedDietaryAdvice
    return foodAdvices.toString()
  }

  function foodDefaultAdvices () {
    var foodAdvices = DietaryAdvice
    return foodAdvices.toString()
  }
  function handleOnSubmit (value) {
    setSelectedPosition(value)
    let floorIndex = 0
    let areaIndex = 0
    value.map((item, index) => {
      const itemObj = JSON.parse(item)
      if (index === 0) {
        floorIndex = itemObj.index
      }
      if (index === 1) {
        areaIndex = itemObj.index
      }
    })
    if (value.length === 3) {
      setFloor(JSON.parse(value[0]).floorName)
      setArea(JSON.parse(value[1]).areaName)
      setBedId(JSON.parse(value[2]).bedName)
      setBedIdSave(JSON.parse(value[2]).bedId)
    }
    getFloorsByArea(areasArr.slice(0), floorIndex, areaIndex)
  }

  function DataCopy (patientDTO, floorIndex, areaIndex) {
    const defaultFloor = JSON.stringify({ floorId: patientDTO.lc_ID, floorName: patientDTO.lc_Name, index: floorIndex })
    const defaultArea = JSON.stringify({ areaId: patientDTO.bq_ID, areaName: patientDTO.bq_Name, index: areaIndex })
    const defaultBed = JSON.stringify({ bedId: patientDTO.patPositionID, bedName: patientDTO.patPositionName })
    const defaultAfb = [defaultFloor, defaultArea, defaultBed]
    return defaultAfb.slice(0)
  }

  /**
   * 当用户更改每一列的选择时改变其他列的显示数据
   * 病区->楼层->床位
   */
  function handleOnColChange (value) {
    let floorIndex = 0
    let areaIndex = 0
    setSelectedPosition(value)
    value.map((item, index) => {
      const itemObj = JSON.parse(item)
      if (index === 0) {
        floorIndex = itemObj.index
      }
      if (index === 1) {
        areaIndex = itemObj.index
      }
    })

    getFloorsByArea(areasArr.slice(0), floorIndex, areaIndex)
  }
  /**
   * 获取所有的楼层
   */

  function getAllAreas (floorId, areaId, patientDTO) {
    const hisCode = window.localStorage.getItem('sdxHisCode')
    request(`/v1/hospitals/${hisCode}/lc`, {
      method: 'GET',
      header: {
        'Accept-Language': languageContext.acceptLanguage
      }
    }).then((res) => {
      if (!res.error) {
        let floorIndex
        res.data.map((item, index) => {
          if (item.id !== floorId) {
          }
          if (item.id === floorId) {
            floorIndex = index
          }
        })
        setAreasArr(res.data.slice(0))
        getDefaultFloorsByArea(res.data, floorIndex, areaId, patientDTO)
      } else {
        Toast.info('获取所有病区出错')
      }
    }).catch((error) => {
      console.error(error)
    })
  }
  /**
   * 根据用户的楼层去获取默认病区
   */
  function getDefaultFloorsByArea (areasTemp, floorIndex, areaId, patientDTO) {
    request(`/v1/hospitals/${HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.hisCode}/${areasTemp[floorIndex].id}/bq`, {
      method: 'GET',
      headers: {
        'Accept-Language': languageContext.acceptLanguage
      }
    }).then((res) => {
      if (!res.error) {
        if (res.data) {
          let areaIndex
          res.data.map((item, index) => {
            if (item.id === areaId) {
              areaIndex = index
            }
          })
          getBedsByFloor(areasTemp, res.data, floorIndex, areaIndex)
          setSelectedPosition(DataCopy(deepCopy(patientDTO), floorIndex, areaIndex))
        } else {
          Toast.hide()
          Toast.info(intl.get('NoWardInfo'), 1)
        }
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 根据用户选择的楼层去获取该病区的所有病区
   */
  function getFloorsByArea (areasTemp, floorIndex, areaIndex) {
    request(`/v1/hospitals/${HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.hisCode}/${areasTemp[floorIndex].id}/bq`, {
      method: 'GET',
      headers: {
        'Accept-Language': languageContext.acceptLanguage
      }
    }).then((res) => {
      if (!res.error) {
        if (res.data) {
          getBedsByFloor(areasTemp, res.data, floorIndex, areaIndex)
        } else {
          Toast.hide()
          Toast.info(intl.get('NoWardInfo'), 1)
        }
      }
    }).catch((error) => {
      console.log(error)
    })
  }

  /**
   * 根据用户选择的病区去获取该病区的所有床位
   */
  function getBedsByFloor (floors, areas, floorIndex, areaIndex) {
    request(`/v1/hospitals/${HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.hisCode}/lc/${areas[areaIndex].id}/patposition`, {
      method: 'GET',
      headers: {
        'Accept-Language': languageContext.acceptLanguage
      }
    }).then((res) => {
      if (!res.error) {
        if (res.data) {
          handleOnGetPickerData(floors, areas, res.data, floorIndex, areaIndex)
        } else {
          Toast.hide()
          Toast.info(intl.get('NoBedInfo'), 1)
        }
      }
    }).catch((error) => {
      console.log(error)
    })
  }
  /**
   * 返回Picker组件需要的格式的数据
   */

  function handleOnGetPickerData (floors, areas, beds, floorIndex, areaIndex) {
    const areasArr = []
    floors.map((floor, index) => {
      const floorObj = {}
      floorObj.label = <div>{floor.name}</div>
      floorObj.value = JSON.stringify({ floorId: floor.id, floorName: floor.name, index: index })

      if (index === floorIndex) {
        const AreaArr = []
        areas.map((area, j) => {
          const areaObj = {}
          areaObj.label = <div>{area.name}</div>
          areaObj.value = JSON.stringify({ areaId: area.id, areaName: area.name, index: j })
          if (j === areaIndex) {
            const bedArr = []
            beds.map((bed) => {
              const bedObj = {}
              bedObj.label = <div>{bed.name}</div>
              bedObj.value = JSON.stringify({ bedId: bed.id, bedName: bed.name })
              bedArr.push(bedObj)
            })
            areaObj.children = bedArr
          } else {
            areaObj.children = []
          }
          AreaArr.push(areaObj)
        })
        floorObj.children = AreaArr
      } else {
        floorObj.children = []
      }

      areasArr.push(floorObj)
    })
    setAreas(areasArr)
  }

  function getSelectedFood (foodObj) {
    const selectedValue = []
    const selectedAdvice = []
    foodObj.map((item) => {
      selectedValue.push(item.value)
      selectedAdvice.push(item.label)
    })
    setDefaultValue(selectedValue)
    setSelectedDietaryAdvice(selectedAdvice)

    setSelectedDietaryAdviceObj(foodObj)
    setVisible(false)
  }

  function handleOnCancel () {
    setVisible(false)
  }
  function fuliterFoodAdvice () {
    const foodAdvices = HospitalBasicInfo.hospitalBasicInfo.foodAdvices
    const dataSource = []
    foodAdvices.map((item) => {
      const tempObj = {}
      tempObj.value = item.id
      tempObj.label = item.advice
      tempObj.spell = item.spell
      dataSource.push(tempObj)
    })
    setFoodAdviceDataSource(dataSource)
  }

  /**
   * 将context里的医院的病区，楼层，床位等数据，整合成符合Picker组件级联时的数据格式
   */
  useEffect(() => {
    if (JSON.stringify(HospitalBasicInfo.hospitalBasicInfo) !== '{}') {
      if (information.currentUser.patientDTO !== null && information.currentUser.patientDTO !== undefined) {
        const patientDTO = information.currentUser.patientDTO
        getAllAreas(patientDTO.lc_ID, patientDTO.bq_ID, patientDTO)

        fuliterFoodAdvice()
      }
    }
  }, [HospitalBasicInfo, information.currentUser])

  //= =======================================================================================================================================
  useEffect(() => {
    if (selectedLanguage[0] !== languageContext.locale) {
      window.sessionStorage.clear()
      let acceptLanguage
      if (selectedLanguage[0] === 'zh') { acceptLanguage = 'zh-CN,zh;q=0.9' } else { acceptLanguage = 'en-US,en;q=0.9' }
      request(`/v1/orderers/language?language=${selectedLanguage[0]}`, { method: 'POST',
        headers: {
          'Accept-Language': acceptLanguage
        } })
        .then(() => {
          languageContext.setLocale(selectedLanguage[0])
        })
    }
  }, [selectedLanguage[0]])

  // 设置病人信息以及订餐人电话号码
  useEffect(() => {
    if (information.currentUser.patientDTO !== null && information.currentUser.patientDTO !== undefined) {
      setIphoneNumber(information.currentUser.mobile)
      setFloor(information.currentUser.patientDTO.lc_Name)
      setArea(information.currentUser.patientDTO.bq_Name)
      setBedId(information.currentUser.patientDTO.patPositionName)
      setNumber(information.currentUser.patientDTO.pid)
      setPatientName(information.currentUser.patientDTO.patientName)
      setAllergen(information.currentUser.patientDTO.allergies)

      // 设置饮食医嘱id数组初始值
      const defaultValueArr = information.currentUser.patientDTO.foodAdvices.map((item) => {
        return item.id
      })
      setDefaultValue(defaultValueArr)
      // 设置饮食医嘱id数组初始值(有value)
      const selectedDietaryAdviceObjCopy = information.currentUser.patientDTO.foodAdvices.map((item) => {
        return { value: item.id }
      })
      setSelectedDietaryAdviceObj(selectedDietaryAdviceObjCopy)
      setDefaultValue(defaultValueArr)
      // 设置饮食医嘱
      const foodAdviceArr = information.currentUser.patientDTO.foodAdvices.map((item) => {
        return item.advice
      })
      setSelectedDietaryAdvice(foodAdviceArr)
      // 饮食医嘱初始值
      setDietaryAdvice(foodAdviceArr)
      // 床位号id初始值
      setBedIdSave(information.currentUser.patientDTO.patPositionID)
    }
  }, [information.currentUser])
  // 解绑函数,解绑成功跳到首页
  function untiedControl () {
    request('/v1/orderers/unbind', { method: 'POST',
      headers: {
        'Accept-Language': languageContext.acceptLanguage
      } })
      .then((res) => {
        setSucPrompt(false)
        if (!res.error) {
          setSucPrompt(false)
          // 判断解绑之后的跳转页面
          if (window.localStorage.getItem('sdxPatPositionId')) {
            window.localStorage.removeItem('sdxPatPositionId')
          }
          information.setCurrentUser(res.data)
          information.setPositionInfo({})
          information.setPatientInfo([])
          information.setPatientInfoByWristband({})
          const urlFir = window.localStorage.getItem('sdxHisCode')
          const urlSec = window.localStorage.getItem('sdxUUID')
          setUntiedSuccess(true)
          if (urlFir !== undefined) {
            if (urlSec !== undefined) {
              OrderInfo.setCacheAllFoodList([])
              window.mySetTime = setTimeout(() => props.history.push(`/index/${urlFir}`), 5000)
            }
          }
        } else {
          setSucPrompt(false)
          setUnsucPrompt(true)
          setMessage(res.message)
        }
      })
  }
  // // 修改病员信息
  function saveInformation () {
    form.append('patPositionId', bedIdSave)
    selectedDietaryAdviceObj.map((item) => {
      form.append('foodAdviceIds', item.value)
    })
    const UUID = window.localStorage.getItem('sdxUUID')
    const sdxUserToken = JSON.parse(window.localStorage.getItem('sdxUserToken'))
    fetch(`${config.server}/v1/patients`, {
      method: 'POST',
      body: form,
      mode: 'cors',
      credentials: 'omit',
      headers: {
        Authorization: sdxUserToken.token_type + sdxUserToken.access_token,
        'Accept-Language': languageContext.acceptLanguage,
        uuid: UUID
      }
    }).then((response) => response.json())
      .then((res) => {
        if (res.data !== 'error') {
          const patientDTO = JSON.parse(JSON.stringify(res.data))
          const currentUser = JSON.parse(JSON.stringify(information.currentUser))
          currentUser.patientDTO = patientDTO
          information.setCurrentUser(currentUser)
          OrderInfo.setCacheAllFoodList([])
          OrderInfo.setIsOrderInfoEmpty(true)
        } else if (res.code === '1102') {
          setUnsucFir(true)
        } else if (res.code === '1405') {
          setUnsucSec(true)
          setErrMessage(intl.get('Update patient information failed'))
        } else if (res.code === '1001') {
          // 没有查询到病员信息
          setUnsucSec(true)
          setErrMessage(res.message)
        } else if (res.code === '1002') {
          // 查询到多个病员信息
          setUnsucSec(true)
          setErrMessage(res.message)
        } else if (res.code === '1003') {
          // 病员已经出院
          setUnsucSec(true)
          setErrMessage(res.message)
        } else if (res.code === '1004') {
          // 未知错误
          setUnsucSec(true)
          setErrMessage(res.message)
        }
      }).catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    console.log(bedId)
  }, [bedId])

  useEffect(() => {
    if (HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo !== undefined
    ) {
      setIsFpspatient(HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.isPfsMaintainPatient)
    }
  }, [HospitalBasicInfo.hospitalBasicInfo])
  return (
    <Styled.Container>
      <Styled.MyNavBarContainer>
        <MyHeaderBg />
        <MyNavBar
          Icon={<Icon size={'md'} color={'white'} type={'left'} />}
          rightContent={<Icon size={'md'} color={'white'} type={'cross'} />}
          history={props.history}
          titleStyle={{ fontFamily: 'YouYuan', fontSize: '1.2rem' }}
        >
          {intl.get('MeAccount')}</MyNavBar>
        <Styled.TelephoneServiceContainer>
          <Styled.IconContainer>
            <StaffIcon height={18} width={18} />
          </Styled.IconContainer>
          <Styled.TelephoneTextContainer>
            {intl.get('Service Hotline')}:
            {
              HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo
                ? <a style={config.theme && { color: config.theme.textColor }} href={`tel:${HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.telephone}`}>
                  <u>{HospitalBasicInfo.hospitalBasicInfo.basicHospitalInfo.properties.telephone}</u>
                </a>
                : ''
            }
          </Styled.TelephoneTextContainer>
        </Styled.TelephoneServiceContainer>
      </Styled.MyNavBarContainer>

      <Styled.MiddleContainer>

        <Styled.MiddleContextContainer>
          <div style={{ fontFamily: 'YouYuan', fontSize: '1.125rem' }} className='pFoodAdviceFlex'>
            <p className='information'>{intl.get('Patient Information')}</p>
            <div style={{ display: isFpspatient ? 'none' : 'block', marginTop: '10%' }}>
              <div className='flex bd6aa8f5 rds20 pl5 pr7' onClick={() => { setEditState(true); setPositionEditable(true) }} >
                <div className='mr8'><EditButton /></div>
                {intl.get('Edit')}
              </div>
            </div>
          </div>
        </Styled.MiddleContextContainer>

        <Styled.ContainerMiddleList>
          <List prefixCls={'myAccountInput'} className={'myAccountInput'}>
            {/* 住院号 */}
            <InputItem
              editable={false}
              className={'myAccountInput'}
              style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989', width: '100%' }}
              value={intl.get('HospitalizationNumber')}
              extra={number}
            >
              <Stethoscope width='40%' />
            </InputItem>
            {/* 病员姓名 */}
            <InputItem
              editable={false}
              className={'myAccountInput'}
              style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989', width: '100%' }}
              value={intl.get('PatientName')}
              extra={patientName}
            >
              <People width='40%' />
            </InputItem>
            {/* 饮食医嘱 */}
            <InputItem
              editable={false}
              className={'myAccountInput'}
              style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989', width: '100%' }}
              value={intl.get('DietaryAdvice')}
              extra={<Styled.AdviceFood >
                <div className='w25px'>

                  <GrayPull style={{ display: foodIconState ? 'block' : 'none' }} onClick={() => { setFoodAdvicesExpansion(true); setfoodIconState(false) }} />
                  <BuleCross style={{ display: foodIconState ? 'none' : 'block' }}onClick={() => { setFoodAdvicesExpansion(false); setfoodIconState(true) }} />
                </div>
                <p className={'font pFoodAdvice '} color={'red'} style={{ lineheight: 23 }}>{foodDefaultAdvices()}</p>
              </Styled.AdviceFood>}
            >
              <Case width={22} height={22} />
            </InputItem>
            <div className='pFoodAdviceFlex' style={{ display: foodAdvicesExpansion ? 'flex' : 'none' }}>
              <p className={'font w85'} style={{ direction: 'rtl' }}>{ foodDefaultAdvices()}</p>
            </div>

            {/* 过敏源Allergen */}
            <InputItem
              editable={false}
              className={'myAccountInput'}
              style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989', width: '100%' }}
              value={intl.get('Allergen')}
              extra={allergen}
            >
              <AllergenIcon width='40%' />
            </InputItem>

            <InputItem
              editable={false}
              className={'myAccountInput'}
              style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989', width: '100%' }}
              value={intl.get('Floor')}
              extra={
                information.currentUser.patientDTO !== null && information.currentUser.patientDTO !== undefined
                  ? information.currentUser.patientDTO.lc_Name
                  : null
              }
            >
              <Hospital width='40%' />
            </InputItem>

            {/** 病区 */}
            <InputItem
              editable={false}
              className={'myAccountInput'}
              style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989', width: '100%' }}
              value={intl.get('InpatientWard')}
              extra={
                information.currentUser.patientDTO !== null && information.currentUser.patientDTO !== undefined
                  ? information.currentUser.patientDTO.bq_Name
                  : null
              }
            >
              <Address width='40%' />
              {/** 楼层 */}

            </InputItem>
            {/** 床位 */}
            <InputItem
              editable={false}
              className={'myAccountLastInput'}
              style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989', width: '100%' }}
              value={intl.get('BedID')}
              extra={
                information.currentUser.patientDTO !== null && information.currentUser.patientDTO !== undefined
                  ? information.currentUser.patientDTO.patPositionName
                  : null
              }
            >
              <Bed width='40%' />
            </InputItem>
          </List>
        </Styled.ContainerMiddleList>
        <Styled.OrdererInformation>
          <p className='information' style={{ fontFamily: 'YouYuan', fontSize: '1.125rem' }}>
            {intl.get('Orderer Information')}</p>
          <List prefixCls={'myAccountInput'} className={'myAccountInput'}>
            {/* 住院号 */}
            <InputItem
              editable={false}
              className={'myAccountLastInput'}
              style={{ fontSize: '0.825rem', fontFamily: 'YouYuan', color: '#898989', width: '100%' }}
              value={intl.get('Contact Number')}
              extra={iphoneNumber}
            />
          </List>
        </Styled.OrdererInformation>
        <Styled.OrdererInformation>
          <p style={{ fontFamily: 'YouYuan', fontSize: '1.125rem', fontWeight: 'bold', marginTop: '10%' }} className='backGround5Se'>
            {intl.get('Other')}</p>
          <div className='phoneNumber' >
            <Picker
              data={data}
              itemStyle={{ textAlign: 'center' }}
              value={selectedLanguage}
              extra={languageArray[selectedLanguage]}
              cols={1}
              onOk={(value) => setSelectedLanguage(value)}
              okText={intl.get('OK')}
              dismissText={intl.get('Cancel')}
            >
              <List.Item arrow='horizontal' className='horizontal'
                style={{ marginTop: '-1.825rem' }}>
                {intl.get('Language')}
              </List.Item>
            </Picker>
            <div >
              <List.Item arrow='horizontal' className='horizontal'
                onClick={() => setSucPrompt(true)}>
                {intl.get('Application for unbinding')}
              </List.Item>
            </div>
          </div>
        </Styled.OrdererInformation>
      </Styled.MiddleContainer>

      <MyModal
        visible={sucPrompt}
        info={intl.get('Whether to unbind')}
        onOkClick={() => { untiedControl() }}
        onCancelClick={() => { setSucPrompt(false) }}
      />
      <MyModal
        visible={unsucPrompt}
        info={message}
        onOkClick={() => { setUnsucPrompt(false) }}
        onCancelClick={() => { setUnsucPrompt(false) }}
      />
      {/* //解绑成功提示窗口 */}
      <MyModal
        visible={untiedSuccess}
        cancelButtonVisible={false}
        info={intl.get('Untied successfully')}
        onOkClick={() => {
          clearTimeout(window.mySetTime)
          OrderInfo.setCacheAllFoodList([])
          props.history.push(`/index/${window.localStorage.getItem('sdxHisCode')}`)
        }}
      />
      {/* //修改信息失败(1102) */}
      <MyModal
        visible={editUnsucFir}
        info={intl.get('There are outstanding orders, editing failed')}
        onOkClick={() => { setUnsucFir(false) }}
        onCancelClick={() => { setUnsucFir(false) }}
      />
      {/* //修改信息失败(1405) */}
      <MyModal
        visible={editUnsucSec}
        cancelButtonVisible={false}
        info={errmessage}
        onOkClick={() => { setUnsucSec(false) }}
      />
      {/* //保存时跳出的提示信息 */}
      <MyModal
        visible={saveTip}
        info={intl.get('Are you sure you want to save the information?')}
        onOkClick={() => { saveInformation(); setSaveTip(false) }}
        onCancelClick={() => { setSaveTip(false) }}
      />
      <IndexList
        defaultValue={defaultValue}
        visible={visible}
        dataSource={foodAdviceDataSource}
        handleOnOkClick={(foodObj) => getSelectedFood(foodObj)}
        handleOnCancelClick={(foodObj) => getSelectedFood(foodObj)}
        onCancel={() => handleOnCancel()}
      />

      {/* //========================================================================================================================== */}
      <div className='backgroungColorAdviceFood' style={{ display: editState ? 'block' : 'none' }}>
        <div className='editInformation'>
          <div className='editInformationStyle '>
            <div className='editInformationTitle'>
              <p >
                {intl.get('Modifypatientinformation')}</p>
            </div>
            <Styled.ListItem>
              <div className='flex' >
                <Stethoscope width={18} height={18} />
                <p className={'nofont'}>{intl.get('HospitalizationNumber')}</p>
              </div>
              <Styled.StyleContainer>
                <p className={'nofont'}>{number}</p>
              </Styled.StyleContainer>
            </Styled.ListItem>
            <Styled.BottomLine></Styled.BottomLine>

            <Styled.ListItem>
              <div className='flex' >
                <People width={18} height={18} />
                <p className={'nofont'}>{intl.get('PatientName')}</p>
              </div>
              <Styled.StyleContainer>
                <p className={'nofont'}>{patientName}</p>
              </Styled.StyleContainer>
            </Styled.ListItem>
            <Styled.BottomLine></Styled.BottomLine>

            {/* ===================================================================================== */}
            <Picker
              onPickerChange={(value) => handleOnColChange(value)}
              disabled={!positionEditable}
              cols={3}
              data={areas}
              title={intl.get('PositionPickerTitle')}
              cascade
              value={selectedPosition}
              onOk={(value) => handleOnSubmit(value)}
              okText={intl.get('OK')}
              dismissText={intl.get('Cancel')}
              itemStyle={{ fontSize: '0.8rem' }}
            >
              <div >
                <Styled.ListItem>
                  <div className='flex' >
                    <Hospital width={18} height={18} />
                    <p className={'font'}>{intl.get('Floor')}</p>
                  </div>
                  <Styled.StyleContainer>
                    <div className='flex'>
                      <p className={'font pfoodadviceEdit fixWidth'}>{floor}</p>
                      <RedPoint />
                      <div className='h20px mt-9 ml-9' >
                        <RightIcon width={30} height={30} />
                      </div>
                    </div>
                  </Styled.StyleContainer>
                </Styled.ListItem>

                <Styled.BottomLine></Styled.BottomLine>

                {/* ===================================================================================== */}
                <Styled.ListItem>
                  <div className='flex' >
                    <Address width={18} height={18} />
                    <p className={'font'}>{intl.get('InpatientWard')}</p>
                  </div>
                  <Styled.StyleContainer>
                    <div className='flex'>
                      <p className={'font pfoodadviceEdit fixWidth'}>{area}</p>
                      <RedPoint />
                      <div className='h20px mt-9 ml-9' >
                        <RightIcon width={30} height={30} />
                      </div>
                    </div>
                  </Styled.StyleContainer>
                </Styled.ListItem>
                <Styled.BottomLine></Styled.BottomLine>
                <Styled.ListItem>
                  <div className='flex' >
                    <Bed width={18} height={18} />
                    <p className={'font'}>{intl.get('BedID')}</p>
                  </div>

                  <Styled.StyleContainer>
                    <div className='flex'>
                      <p className={'font pfoodadviceEdit fixWidth'}> {bedId}</p>
                      <RedPoint />
                      <div className='h20px mt-9 ml-9' >
                        <RightIcon width={30} height={30} />
                      </div>
                    </div>
                  </Styled.StyleContainer>
                  {/* ===================================================================================== */}
                </Styled.ListItem>
              </div>
            </Picker>
            <Styled.BottomLine></Styled.BottomLine>

            <Styled.ListItem>
              <div className='flex' >
                <Case width={20} height={20} />
                <p className={'font'}>{intl.get('DietaryAdvice')}</p>
              </div>
              {/* ===================================================================================== */}

              <div className='pFlex' onClick={() => { setVisible(true) }} >

                <p className={'font pfoodadviceEdit fixWidth'}> {foodAdvices()}</p>
                <div className='w43px flex ' >
                  <RedPoint />
                  <div className='h20px mt-9 ml-9' >
                    <RightIcon width={30} height={30} />
                  </div>

                </div>
              </div>
            </Styled.ListItem>
            <Styled.BottomLine></Styled.BottomLine>
            <div className='editInformationBottom '>
              <div className='editInformationCancle' onClick={() => { setEditState(false) }}>
                {intl.get('Cancel')}
              </div>
              <div className='editInformationOk' onClick={() => { setEditState(false); setSaveTip(true) }} >
                {intl.get('Save')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Styled.Container>

  )
}
